import React from "react";

const Card = ({ children, className = "", padding = "default" }) => {
  const paddingStyles = {
    small: "p-4",
    default: "p-4 sm:p-6 md:p-8",
    large: "p-6 sm:p-8 md:p-10",
    none: "p-0",
  };

  return (
    <div
      className={`rounded-2xl border border-[var(--border-color)] bg-[var(--bg-card)] transition-all duration-300 hover:-translate-y-0.5 dark:shadow-lg dark:shadow-primary/10 shadow-sm shadow-slate-200/60 ${paddingStyles[padding]} ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
